module.exports = __webpack_public_path__ + "img/no_image.56d6e7e1.jpg";